import { api } from "./../../api.js";
import { vue_instance } from './../../main.js';
//import api_routes from './../../api_routes.js';

import axios from "axios";

const state = {
  token: null,
  is_logged: false,
  role: 0, //de momento, 1 para admin, 2 para organization, 3 para sme
  menu_active: false,
  search_active: false,
  user_content_active: false,
  page_loading: false,
  permissions: [],
  name: "",
  user: null,
  country_code: "",
  organizations: [],
  current_organization: "",
  actions: [],
  hide_purchased_hour: 0,
  server_error: false,
  router_status: null
};

const getters = {
  getUserToken: state => {
    return state.token;
  },
  isLogged: state => {
    return state.is_logged;
  },
  getRole: state => {
    return state.role;
  },
  getMenuActive: state => {
    return state.menu_active;
  },
  getSearchActive: state => {
    return state.search_active;
  },
  getUserContentActive: state => {
    return state.user_content_active;
  },
  getPageLoading: state => {
    return state.page_loading;
  },
  getPermissions: state => {
    return state.permissions;
  },
  getName: state => {
    return state.name;
  },
  getUser: state => {
    return state.user;
  },
  getDownloadToken: state => {
    return state.user.download_token;
  },
  getCountryCode: state => {
    return state.country_code;
  },
  getUserOrganizations: state => {
    return state.organizations;
  },
  getCurrentOrganization: state => {
    return state.current_organization;
  },
  getHidePurchasedHour: state => {
    return state.hide_purchased_hour;
  },
  getMetaActions: state => {
    return state.actions;
  },
  getServerError: state => {
    return state.server_error;
  },
  getRouterStatus: state => {
    return state.router_status;
  }
};

const mutations = {
  setUserToken: (state, token) => {
    state.token = token;
    localStorage.setItem("token", token);
  },

  setIsLogged: (state, is_logged) => {
    state.is_logged = is_logged;
  },

  setRole: (state, role) => {
    state.role = role;
  },
  setMetaActions: (state, actions) => {
    state.actions = actions;
    localStorage.setItem("meta_actions", actions);
  },
  setMenuActive: state => {
    state.search_active = false;
    state.user_content_active = false;
    state.menu_active = !state.menu_active;
  },
  setSearchActive: state => {
    state.menu_active = false;
    state.user_content_active = false;
    state.search_active = !state.search_active;
  },
  setUserContentActive: state => {
    state.menu_active = false;
    state.search_active = false;
    state.user_content_active = !state.user_content_active;
  },
  setPageLoading: (state, loading) => {
    state.page_loading = loading;
  },
  setPermissions: (state, permissions) => {
    state.permissions = permissions;
  },
  setCountryCode: (state, code) => {
    state.country_code = code;
  },
  setName: (state, name) => {
    state.name = name;
  },
  setUser: (state, user) => {
    state.user = user;
  },
  setUserCurrentOrganization: (state, org) => {
    state.current_organization = org;
  },
  setUserCurrentOrganizationHidePurchasedHours: (state, hide) => {
    state.hide_purchased_hour = hide;
  },
  setUserOrganizations: (state, org) => {
    state.organizations = org;
  },
  setServerError: (state, error) => {
    state.server_error = error;
  },
  setRouterStatus: (state, router) => {
    state.router_status = router
  }
};

const actions = {
  login: function({ dispatch, commit }, data) {
    //return a promise to catch the response outside vuex in LoginComponent
    return new Promise((resolve, reject) => {
      api
        .post("login", data.login_data)
        .then(res => {
          if (res.data.auth) {
            commit("setUserToken", res.data.access_token);
            commit("setIsLogged", res.data.auth);
            commit("setRole", res.data.user.view);
            commit("setMetaActions", res.data.user.meta_actions);
            if (res.data.user.view == "organization") {
               if (res.data.user.country_code) {
                commit('setCountryCode',res.data.user.country_code)
              }
              dispatch("getMultiUserOrganizations", {}).then(() => {
                dispatch("getUserOrganization", {}).then(() => {});
              });
            }
            commit("setPermissions", res.data.user.permissions);
            commit("setName", res.data.user.name);
            commit("setUser", res.data.user);
          } else {
            reject(res);
          }

          resolve(res);
        })
        .catch(error => {
         // resolve(error);
          reject(error);
        });
    });

    //OFFLINE TEST LOGIN
    /*var usernames = ['admin', 'organization', 'sme'];

		if(usernames.indexOf(data.login_data.email) > -1){
			var route_prefix = '';
			switch(data.login_data.email){
				case 'admin':
					commit('setRole', 1); route_prefix = 'admin'; break;
				case 'organization' :
					commit('setRole', 2); route_prefix = 'organization'; break;
				case 'sme' :
					commit('setRole', 3); route_prefix = 'sme'; break;

				default : break;
			}

			data.router.push({ name : route_prefix+'.dashboard' });
			commit('setUserToken', 'token');
			commit('setIsLogged', true);
		}else{
			commit('setErrorLogin', true);
			commit('setMessageErrorLogin', 'Login incorrecto');
		}*/
  },

  logout: function({ commit }, data) {
    /*api().post(api_routes.LOGOUT).then((res) => {
			localStorage.removeItem('token');
			commit('setUserToken', null);
			commit('setIsLogged', false);
			data.router.push({ name : 'login' });
		});*/

    data.router.push({ name: "login" });
    commit("setUserToken", null);
    commit("setIsLogged", false);
    commit("setPermissions", []);
    commit("setUserCurrentOrganization", "");
    commit("setUserOrganizations", []);
    commit("setUser", null);
    commit("setRole", 0);
    commit("setMetaActions", []);
    localStorage.removeItem("current_organization");
    localStorage.removeItem("organizations");
  },
  checkAccessToken: function ({ commit, dispatch }, data) {
    console.log("CHECK ACCESS TOKEN METHOD");
      var params = {

      };
      if(data && data.filters){
        params.filters = data.filters
      }else{
        params.filters = {}
        params.filters.page_loading = false
      }
    if (localStorage.getItem("token")) {
      //aquí tendríamos un check del token
      return new Promise((resolve, reject) => {
        api
          .post("check-access-token",params)
          .then(res => {
            commit("setUserToken", localStorage.getItem("token"));
            commit("setIsLogged", true);
            commit("setRole", res.data.user.view);
            if (res.data.user.view == "organization") {
              if (res.data.user.organization_roles) {
                commit("setUserOrganizations", res.data.user.organization_roles);
              }
              dispatch("getMultiUserOrganizations", {}).then(() => {
                dispatch("getUserOrganization", {}).then(
                  () => {}
                );
              });
            }
            commit("setMetaActions", res.data.user.meta_actions);
            commit("setCountryCode", res.data.user.country_code);
            commit("setPermissions", res.data.user.permissions);
            commit("setName", res.data.user.name);
            commit("setUser", res.data.user);
            resolve(res);
          })
          .catch(error => {
            commit("setUserToken", null);
            console.log(error);
            commit("setIsLogged", false);
            commit("setPermissions", []);
            commit("setUser", null);

            // commit("setServerError", false);
            // vue_instance.$router.push({ name: "login" });
            reject(error);
          });
      });
    }
  },

  sendResetPasswordEmail: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("send-reset-password/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  forgotPassword: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("reset-password", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  resetPassword: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("self-reset-pass", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  validatePassword: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("validate-password", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          resolve(error);
        });
    });
  },
  checkEmail: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/providers/"+data.provider_id +"/check-email", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          resolve(error);
        });
    });
  },
  editProfile: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch("profile", data)
        .then(res => {
          commit("setName", res.data.user.name);
          commit("setUser", res.data.user);

          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getMyOrganization: function({ commit }, data) {
    //return a promise to catch the response outside vuex in LoginComponent
    return new Promise((resolve, reject) => {
      api
        .get("organization", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getMultiUserOrganizations: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      var params = { filters: data.filters };

      api
        .get("organizations", params)
        .then(res => {
          commit("setUserOrganizations", res.data);
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getUserOrganization: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      var params = { filters: data.filters };

      api
        .get("organization", params)
        .then(res => {
          commit("setUserCurrentOrganization", res.data.organization.name);
          commit("setUserCurrentOrganizationHidePurchasedHours", res.data.organization.hide_purchased_hours);
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  changeUserOrganization: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("organizations/" + data.id + "/login", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/AuthModule.js